import { render, staticRenderFns } from "./campaignsOverview.vue?vue&type=template&id=12b5d8fe&lang=pug"
import script from "./campaignsOverview.vue?vue&type=script&lang=js"
export * from "./campaignsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports